/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileGif = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M14.398 11.887c.211 0 .42.019.627.055.212.037.41.092.594.165v.912a4.215 4.215 0 0 0-.628-.152 3.195 3.195 0 0 0-.551-.049c-.53 0-.937.14-1.222.421-.28.276-.421.675-.421 1.195 0 .579.122 1.014.365 1.303.248.285.626.428 1.132.428.193 0 .382-.011.566-.034.023-.003.046-.008.069-.01v-.973l-.849-.28v-.58h1.857v2.464a3.64 3.64 0 0 1-1.076.304 4.197 4.197 0 0 1-.594.04c-.847 0-1.488-.225-1.925-.676-.432-.45-.649-1.113-.649-1.986 0-.539.106-.996.318-1.374.216-.381.523-.672.924-.87.404-.202.892-.303 1.463-.303zM17.827 17h-1.076v-5.017h1.076zm4.181-4.105h-2.126v1.262h1.884v.911h-1.884V17h-1.076v-5.017h3.202z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileGif as FileGif };
